import axios from 'axios';
import { Event, SubEvent } from 'inscreva-sse-models';
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';

import store from '.';
import { EventUI } from '../models/event-ui';
import { Form } from '../models/form';
import { Subscription } from '../models/subscription';
import config from '../utils/config';

@Module({
  name: 'eventUIStore',
  dynamic: true,
  namespaced: true,
  store,
})
export default class EventUIStore extends VuexModule {
  _eventUI: EventUI;

  @Mutation
  fromEvent(event: Event | SubEvent) {
    this._eventUI = new EventUI(event);
  }

  @Action({ commit: 'select' })
  async fromAlias(alias: string): Promise<EventUI> {
    const event = (await axios.get(`${config.getAPIAddress()}/event/${alias}`)).data;
    const _eventUI = event && new EventUI(event as Event);

    return _eventUI;
  }

  @Action
  async getAccess(options: { alias: string; email: string; accessKey: string }) {
    return axios
      .post(`${config.getAPIAddress()}/event/${options.alias}/auth`, {
        email: options.email,
        accessKey: options.accessKey,
      })
      .then((res) => res.data)
      .catch((err) => err.response);
  }

  @Action
  async resendEmail(options: { alias: string; email: string }) {
    return axios
      .put(`${config.getAPIAddress()}/subscription/resend/${options.alias}/${options.email}`)
      .then((res) => res.data)
      .catch((err) => err.response);
  }

  @Mutation
  select(_eventUI: EventUI): void {
    this._eventUI = _eventUI;
  }

  @Action({ commit: 'select', rawError: true })
  async save(eventUI: EventUI): Promise<EventUI> {
    const response = await axios
      .post<Subscription>(`${config.getAPIAddress()}/subscription`, {
        event: eventUI.event,
        subscription: Subscription.fromEvent(eventUI.event as Event),
        form_values: Form.buildFormData(eventUI.event as Event, {
          withMeta: true,
          onlyGroup: 'personal-info',
          mode: 'iterable',
        }),
        notification: this.eventUI.notification,
        timezone: this.eventUI.timezone,
      })
      .catch((error) => {
        throw error.response.data;
      });

    eventUI.subscription = response.data;

    return eventUI;
  }

  get eventUI(): EventUI {
    return this._eventUI;
  }
}

export const eventUIStore = getModule<EventUIStore>(EventUIStore, store);
